import { MrbBaseRouteStore } from "mrb/core";
import { LoadioContentProfileService, LoadioDeviceContentProfileService } from "common/services";

class LoadioDeviceListRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);
        this.deviceProfileService = rootStore.createApplicationService(LoadioDeviceContentProfileService);
        this.contentProfileService = rootStore.createApplicationService(LoadioContentProfileService);
    }

    async findDevices(params) {
        const response = await this.deviceProfileService.find(params);
        return response.data;
    }

    async findProfiles(params) {
        const response = await this.contentProfileService.find({ sort: "name|asc", ...params });
        return response.data;
    }

    async assignProfile(deviceId, profileId) {
        return this.deviceProfileService.assignProfile(deviceId, profileId);
    }

    async batchAssignProfile(deviceIds, profileId) {
        return this.deviceProfileService.batchAssignProfile(deviceIds, profileId);
    }
}

export default LoadioDeviceListRouteStore;
